export default __webpack_public_path__ + "static/media/CheckMarkIcon.c0e6b7fa.svg";